import { CHILD_MIN_WIDTH } from '../../../../../../excelPreview/excelPreview.constants'

export const styles = {
    childS: {
        minWidth: CHILD_MIN_WIDTH,
        width: '100%'
    }
}
